<template>
  <div>
    <van-nav-bar
      title="无效页面"
      left-arrow
      fixed
      @click-left="onClickLeft"
    >   </van-nav-bar>
    <van-empty image="error" description="请求页面无效" />
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    onClickLeft() {
      this.$router.push({
        path: '/work'
      })
    },
  }
}
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/views/NotFound/index.vue